<template>
  <icon-base
    :title="title"
    :name="name"
    :viewbox="viewBox">
    



<g>
	<path d="M20.787,5.756c-0.23,0-0.445-0.103-0.588-0.284c-0.48-0.605-1.029-1.157-1.63-1.643c-1.889-1.524-4.162-2.33-6.573-2.33
		c-0.377,0-0.76,0.021-1.137,0.061C8.069,1.859,5.563,3.226,3.802,5.409C3.658,5.586,3.446,5.688,3.218,5.688l0,0
		c-0.171,0-0.338-0.059-0.47-0.166c-0.322-0.26-0.373-0.733-0.113-1.055c2.013-2.495,4.877-4.057,8.065-4.398
		C11.13,0.023,11.567,0,11.998,0c2.757,0,5.355,0.921,7.514,2.662c0.687,0.554,1.314,1.186,1.863,1.877
		c0.125,0.157,0.18,0.353,0.158,0.552c-0.023,0.199-0.122,0.377-0.279,0.502C21.121,5.698,20.956,5.756,20.787,5.756z"/>
	<path d="M12.012,24.003c-0.574,0-1.157-0.042-1.731-0.125c-3.166-0.456-5.965-2.117-7.881-4.678c-0.12-0.16-0.17-0.358-0.142-0.556
		c0.029-0.198,0.133-0.374,0.293-0.494C2.682,18.053,2.837,18.001,3,18.001c0.235,0,0.46,0.112,0.601,0.3
		c1.676,2.24,4.125,3.694,6.894,4.093c0.503,0.072,1.013,0.109,1.516,0.109c2.263,0,4.426-0.723,6.253-2.09
		c0.794-0.594,1.499-1.297,2.095-2.09c0.141-0.188,0.365-0.3,0.6-0.3c0.164,0,0.32,0.052,0.451,0.151
		c0.33,0.248,0.397,0.719,0.148,1.05c-0.682,0.907-1.488,1.711-2.396,2.39C17.073,23.177,14.6,24.003,12.012,24.003z"/>
	<path d="M1.5,16.501c-0.414,0-0.75-0.336-0.75-0.75v-6c0-1.241,1.009-2.25,2.25-2.25h1.5c0.414,0,0.75,0.336,0.75,0.75
		s-0.336,0.75-0.75,0.75H3c-0.414,0-0.75,0.336-0.75,0.75v2.25h1.5c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75h-1.5v2.25
		C2.25,16.165,1.914,16.501,1.5,16.501z"/>
	<path d="M10.5,16.501c-0.262,0-0.509-0.14-0.643-0.364L8.25,13.459v2.292c0,0.414-0.336,0.75-0.75,0.75s-0.75-0.336-0.75-0.75v-7.5
		c0-0.414,0.336-0.75,0.75-0.75h1.125c1.447,0,2.625,1.178,2.625,2.625c0,1.134-0.728,2.119-1.763,2.478l1.656,2.761
		c0.103,0.172,0.133,0.373,0.084,0.568s-0.17,0.358-0.342,0.461C10.77,16.464,10.636,16.501,10.5,16.501z M8.625,11.251
		c0.62,0,1.125-0.505,1.125-1.125S9.245,9.001,8.625,9.001H8.25v2.25H8.625z"/>
	<path d="M15,16.501c-1.241,0-2.25-1.009-2.25-2.25v-4.5c0-1.241,1.009-2.25,2.25-2.25h1.5c0.414,0,0.75,0.336,0.75,0.75
		s-0.336,0.75-0.75,0.75H15c-0.414,0-0.75,0.336-0.75,0.75v2.25h2.25c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75h-2.25
		v0.75c0,0.414,0.336,0.75,0.75,0.75h1.5c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75H15z"/>
	<path d="M21,16.501c-1.241,0-2.25-1.009-2.25-2.25v-4.5c0-1.241,1.009-2.25,2.25-2.25h1.5c0.414,0,0.75,0.336,0.75,0.75
		s-0.336,0.75-0.75,0.75H21c-0.414,0-0.75,0.336-0.75,0.75v2.25h2.25c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75h-2.25
		v0.75c0,0.414,0.336,0.75,0.75,0.75h1.5c0.414,0,0.75,0.336,0.75,0.75s-0.336,0.75-0.75,0.75H21z"/>
</g>


  </icon-base>
</template>

<script>
import IconBase from '../IconBase';

export default {
  components: {
    IconBase,
  },
  props: {
    title: {
      type: String,
      required: false,
      default: 'tag-free-circle',
    },
    name: {
      type: String,
      required: false,
      default: 'TagFreeCircle',
    },
    viewBox: {
      type: String,
      required: false,
      default: '0 0 24 24',
    },
  },
};
</script>

<style scoped>
  
</style>